import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Skeleton } from '@mui/material';
import { memo } from 'react';
export const SkeletonPanel = memo(function SkeletonPanel(props) {
    const { size = 5 } = props;
    const cards = Array(size).fill(null);
    const skeleton_cards = cards.map((_, index) => (_jsx(Skeleton, { variant: "rounded", animation: "wave", width: "100%", height: 100 }, index)));
    return (_jsxs(Box, { display: "flex", flexDirection: "column", rowGap: 2, width: "100%", children: [_jsx(Skeleton, { variant: "rounded", animation: "wave", width: "100%", height: 40 }), _jsx(Box, { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(165px, 1fr))", gridTemplateRows: "repeat(auto-fit, minmax(100px, 1fr))", gap: 1, children: skeleton_cards })] }));
});
